import React from "react";

import BaseUpdateCard, { type CardStatus } from "./BaseCard";

type Props = {
  status: CardStatus;
};

function DownloadingCard({ status }: Props): React.JSX.Element {
  return (
    <BaseUpdateCard
      status={status}
      title={"Downloading"}
      subtitle={"Downloading new features..."}
      iconName={"arrow-down"}
    />
  );
}

export default DownloadingCard;
